import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { useRouter } from 'solito/router'
import { RoundedButton } from '@components/ButtonsAlt/RoundedButton'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

const GUTTER = 16

export function ViewMore() {
  const { push } = useRouter()

  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
      }}
    >
      <Text style={styles.headline}>Want more stories?</Text>
      <RoundedButton
        text="Read More"
        onPress={() => push('/stories')}
        backgroundColor={Colors.primary}
        textColor={Colors.white}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  headline: {
    fontSize: Fonts.size.h6,
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    paddingBottom: GUTTER / 2,
  },
})
